import { EMRdetailsProps } from "@/api_framework/api_modals/EMRs";
import MandatoryLabel from "@/app/components/ui/Reusable/MandatoryLabel";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useStaticPrognosisAPI } from "@/app/hooks/api_hooks/emr/useStaticPrognosisAPI";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const PrognosisComponent = ({ emrDetails, setEmrDetails, errorMessage, setErrorMessage }: EMRdetailsProps) => {
  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();
  const { data: prognosisList, execute: fetchPrognosisList } = useStaticPrognosisAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      emr_template: "",
    },
  });

  useEffect(() => {
    if (emrDetails) {
      formHook.setValue("prognosis", emrDetails?.prognosis);
    }
  }, [emrDetails]);

  const [initialLoad, setInitialLoad] = useState<boolean>(false);

  useEffect(() => {
    if (!initialLoad) {
      setInitialLoad(true);
      return;
    }
    const prognosis = formHook.watch("prognosis");

    if (prognosis) {
      const constructedBody = {
        emr_status: emrDetails?.emr_status,
        prognosis: prognosis,
      };

      updateEmrAPI(emr_id, constructedBody).then(({ status, message }) => {
        if (status) {
          setEmrDetails(message);
        }
      });
    }
  }, [formHook.watch("prognosis")]);

  const prognosisItems = useSelectMenuReducer(prognosisList, "prognosis_name", "prognosis_name");

  useEffect(() => {
    fetchPrognosisList(emrDetails?.visited_clinic_id);
  }, [emrDetails?.visited_clinic_id]);

  return (
    <div className="flex items-center justify-between w-full  bg-white p-3 rounded-[10px] mt-3">
      <div className="bg-[#F9FAFB] w-full rounded-xl p-2 py-4 flex flex-col gap-2 sm:flex-row sm:items-center">
        <h3 className="shrink-0 text-[#000000] font-medium tracking-tight42 text-sm">
          Prognosis <MandatoryLabel label="*" className="text-xs text-[#ED0101] " />{" "}
        </h3>

        <SearchableSelectMenu
          errorMessages={[{ message: "", type: "required" }]}
          onSelectItem={(item) => {
            if (item) {
              formHook.setValue("prognosis", item.id);
              setErrorMessage((prev: string[] | null) => {
                if (!prev) return prev;
                return prev.filter((msg) => msg !== "Prognosis");
              });
            }
          }}
          fieldError={formHook?.formState?.errors?.prognosis}
          register={formHook.register(`prognosis`, { required: true })}
          selectItems={prognosisItems}
          placeholder="Select Prognosis"
          showTooltips={true}
          showTypedErrors={true}
          showDropdownIcon={true}
          defaultSelected={prognosisItems?.filter((oc) => oc.id === formHook.watch(`prognosis`))[0]}
          listBoxClassName="w-full"
          className="text-[#000000]"
          containerClassName="w-full sm:w-72"
        />
        {errorMessage?.includes("Prognosis") && (
          <span className="text-red-500 sm:pl-4 text-xs">Pick one option to finish EMR</span>
        )}
      </div>
    </div>
  );
};
export default PrognosisComponent;
